import { graphql } from 'relay-runtime';

export const INITIALIZE_TRANSACTION_MUTATION = graphql`
  mutation InitializeTransactionMutation {
    unified {
      linking {
        initializeLinkingWithLoggedInAccount {
          ... on UnifiedLinkInitiationPayload {
            id
            token
          }
          ... on UnifiedLinkingStatusPayload {
            message
            success
            errors {
              extensions {
                errorType
                statusCode
              }
              code
              message
            }
          }
        }
      }
    }
  }
`;
